/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.mapStateToProps = exports.BaseSpecifications = void 0;

var react_1 = __importDefault(require("react"));

var brightsmith_core_1 = require("brightsmith-core");

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var name = 'BaseSpecifications';
exports.name = name;

var BaseSpecifications = function BaseSpecifications(_ref) {
  var Frame = _ref.Frame,
      Text = _ref.Text,
      List = _ref.List,
      ListItem = _ref.ListItem,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Comp) {
    _inherits(_class, _react_1$default$Comp);

    var _super = _createSuper(_class);

    function _class(props) {
      _classCallCheck(this, _class);

      return _super.call(this, props);
    }

    _createClass(_class, [{
      key: "renderItems",
      value: function renderItems(classes) {
        var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        return react_1.default.createElement(List, {
          className: ['BaseSpecifications__list', classes === null || classes === void 0 ? void 0 : classes.list],
          style: styles === null || styles === void 0 ? void 0 : styles.list
        }, Object.values(items).map(function (attribute) {
          var property = items[attribute];
          return react_1.default.createElement(ListItem, {
            className: ['BaseSpecifications__list-item', classes === null || classes === void 0 ? void 0 : classes.listItem],
            style: styles === null || styles === void 0 ? void 0 : styles.listItem
          }, react_1.default.createElement(Text, {
            className: ['BaseSpecifications__text-bold', classes === null || classes === void 0 ? void 0 : classes.bold],
            style: styles === null || styles === void 0 ? void 0 : styles.bold
          }, attribute), property);
        }));
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            after = _this$props.after,
            baseSpecifications = _this$props.baseSpecifications,
            before = _this$props.before,
            classes = _this$props.classes,
            options = _this$props.options,
            _this$props$opts = _this$props.opts,
            opts = _this$props$opts === void 0 ? {} : _this$props$opts;
        var optionsTitle = opts.optionsTitle,
            showOptions = opts.showOptions,
            title = opts.title;
        return react_1.default.createElement(Frame, {
          className: ['BaseSpecifications__container', classes === null || classes === void 0 ? void 0 : classes.container],
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, before, react_1.default.createElement(Text, {
          className: ['BaseSpecifications__title', classes === null || classes === void 0 ? void 0 : classes.title],
          style: styles === null || styles === void 0 ? void 0 : styles.title
        }, title || 'Base Specifications'), this.renderItems(classes, baseSpecifications), showOptions && react_1.default.createElement(Frame, null, react_1.default.createElement(Text, null, optionsTitle || 'Options/Accessories'), this.renderItems(classes, options)), after);
      }
    }]);

    return _class;
  }(react_1.default.Component);
};

exports.BaseSpecifications = BaseSpecifications;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var api = state.api;
  var configuration = api.configuration;
  var db = new BrightsmithDb(api);
  var options = {};
  Object.keys(configuration).forEach(function (attributeId) {
    var attribute = db.getAttribute(attributeId);
    var property = db.getProperty(configuration[attributeId]);
    options[attribute.name] = property.name;
  });
  var model = db.getCurrentModel();
  var baseSpecifications = model.baseSpecifications;
  return {
    baseSpecifications: baseSpecifications,
    options: options
  };
};

exports.mapStateToProps = mapStateToProps;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f;

  return {
    container: Object.assign({
      display: 'flex',
      flexDirection: 'column'
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.BaseSpecifications) === null || _a === void 0 ? void 0 : _a.container),
    bold: Object.assign({
      fontWeight: 'bold'
    }, (_b = theme === null || theme === void 0 ? void 0 : theme.BaseSpecifications) === null || _b === void 0 ? void 0 : _b.bold),
    list: Object.assign({
      display: 'flex',
      flexDirection: 'column'
    }, (_c = theme === null || theme === void 0 ? void 0 : theme.BaseSpeciciations) === null || _c === void 0 ? void 0 : _c.list),
    listItem: Object.assign({
      flex: 1,
      width: '33.3%'
    }, (_d = theme === null || theme === void 0 ? void 0 : theme.BaseSpeciciations) === null || _d === void 0 ? void 0 : _d.listItem),
    title: Object.assign({
      color: (_e = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _e === void 0 ? void 0 : _e.primary,
      fontSize: 28,
      fontWeight: '100',
      marginBottom: 10,
      textAlign: 'center'
    }, (_f = theme === null || theme === void 0 ? void 0 : theme.BaseSpecifications) === null || _f === void 0 ? void 0 : _f.title)
  };
};

exports.style = style;